/**
 * 配置文件
 * 公共方法
 * */
import vm from 'vue';

/**公用配置参数*/
var config = {
  // baseURL:' http://192.168.50.80:8000/vehicle',//服务器
  baseURL: process.env.VUE_APP_BASE_API,
  empCode: 'SEVEN',
  empNikeName: "水电七局",
  empFullName: '中国水利水电第七工程局有限公司'
};
vm.prototype.$config = config;